import { processPaymentCall } from "./api/paymentService";
import NotificationService from "../components/Notification/notificationService";
import LoginService from "./loginService";

export default function PaymentService() {
  const { error: errorNotification } = NotificationService();
  const { setLogout } = LoginService();

  const handleError = (status: number, description: string) => {
    if (status === 401) {
      setLogout();
    } else {
      errorNotification(description);
    }
  };

  const processPayment = async (paymentMethod: string, isMonthly: boolean) => {
    let response = await processPaymentCall(paymentMethod, isMonthly).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );

    return response === 200;
  };

  return {
    processPayment,
  };
}
